exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".color[data-v-c7667a4a]{color:#a2c037}.application[data-v-c7667a4a]{font-family:Rubik,sans-serif}", "", {"version":3,"sources":["/app/src/components/politics/PrivacyPolicies.vue"],"names":[],"mappings":"AACA,wBACI,aAAe,CAClB,AACD,8BACE,4BAAiC,CAClC","file":"PrivacyPolicies.vue","sourcesContent":["\n.color[data-v-c7667a4a] {\n    color: #a2c037;\n}\n.application[data-v-c7667a4a] {\n  font-family: \"Rubik\", sans-serif;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c7667a4a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/politics/PrivacyPolicies.vue
// module id = 498
// module chunks = 17